<div *ngFor="let notification of (activeSystemNotifications$ | async)"
     class="informational system-notification">
  <figure class="icon"><i class="fa fa-info-circle"></i></figure>
  <span [innerHTML]="notification.message"></span>
</div>
<mdb-navbar SideClass="navbar navbar-expand-xl navbar-dark indigo lighten-3 py-0" [containerInside]="false"
            id="mobile-navbar">
  <logo class="w-100 d-flex justify-content-start align-items-center">
    <span [translate]="Localization.MobileWarning" class="mr-2 font-weight-400"></span>
  </logo>
</mdb-navbar>
<mdb-navbar *ngIf="isUserOnDemo" SideClass="navbar navbar-expand-xl navbar-dark indigo lighten-5 py-0"
            [containerInside]="false"
            id="demo-navbar">
  <logo class="w-100 d-flex justify-content-start align-items-center">
    <span *ngIf="demoSubscriptionDaysLeft == null" [translate]="Localization.YouHaveADemoSubscription"
          class="mr-2 font-weight-400">
    </span>
    <span *ngIf="demoSubscriptionDaysLeft > 1" [translateParams]="{ value: demoSubscriptionDaysLeft }"
          [translate]="Localization.YourSubscriptionWillExpireInDays"
          class="mr-2 font-weight-400">
    </span>
    <span *ngIf="demoSubscriptionDaysLeft === 1" [translate]="Localization.YourSubscriptionWillExpireTomorrow"
          class="mr-2 font-weight-400">
    </span>
    <span *ngIf="demoSubscriptionDaysLeft === 0" [translate]="Localization.YourSubscriptionWillExpireToday"
          class="mr-2 font-weight-400">
    </span>
    <ng-template #popTemplate>
      <span [translateParams]="{
          value: demoSubscriptionExpireDate | date: appConfig.DATE_FORMAT
        }" [translate]="Localization.YourSubscriptionWillBeValidUntil" class="font-weight-400">
      </span>
    </ng-template>
    <chapps-secondary-button (clicked)="goToSubscriptionPage()" *ngIf="demoSubscriptionDaysLeft != null"
                             [label]="Localization.Subscribe | translate"
                             [mdbTooltip]="popTemplate" [outline]="false" [small]="true"
                             placement="right">
    </chapps-secondary-button>
    <chapps-secondary-button (clicked)="goToSubscriptionPage()" *ngIf="demoSubscriptionDaysLeft == null"
                             [label]="Localization.Subscribe | translate"
                             [outline]="false" [small]="true">
    </chapps-secondary-button>
  </logo>
</mdb-navbar>
<mdb-navbar SideClass="navbar navbar-expand-xl navbar-dark indigo darken-1 pb-0 pt-0" [containerInside]="false">
  <logo>
    <label class="navbar-brand d-flex align-items-center" href="#">
      <chapps-apps-list [applicationName]="Localization.ChappsManager"></chapps-apps-list>

      <h5 *ngIf="hasLiteSubscription()" [translate]="Localization.Lite" class="lite-badge"></h5>
    </label>
  </logo>
  <links>
    <ul class="navbar-nav ml-auto pb-2 pt-2">
      <li [hidden]="shouldShowOnlyAccountSection()" [ngClass]="{ 'active amber rounded': isBuildingsButtonActive }"
          class="nav-item">
        <a class="nav-link waves-light pl-3 pr-3" mdbRippleRadius routerLink="/buildings" routerLinkActive="active">
          <span><img src="assets/images/navbar/buildings.svg"/> {{ Localization.Buildings | translate }}</span>
        </a>
      </li>
      <li [ngClass]="{ 'active amber rounded': isIssuesButtonActive }"
          class="nav-item">
        <a class="nav-link waves-light pl-3 pr-3" mdbRippleRadius routerLink="/issues" routerLinkActive="active">
          <span><img src="assets/images/navbar/issues.svg"/> {{ Localization.Issues | translate }}</span>
        </a>
      </li>
      <li *ngIf="hasMaintenanceProduct"
          class="nav-item">
        <a class="nav-link waves-light pl-3 pr-3"
           mdbRippleRadius
           routerLink="/maintenance" routerLinkActive="active">
          <span><img src="assets/images/navbar/toolbox.svg"/> {{ Localization.Maintenance | translate }}</span>
        </a>
      </li>
      <li *ngIf='hasInspectionFeature() | async' [hidden]="shouldShowOnlyAccountSection()"
          [ngClass]="{ 'active amber rounded': isInspectionsButtonActive }"
          class="nav-item">
        <a class="nav-link waves-light pl-3 pr-3" mdbRippleRadius routerLink="/inspections/list"
           routerLinkActive="active">
          <span><img src="assets/images/navbar/inspections.svg"/> {{ Localization.Inspections | translate }}</span>
        </a>
      </li>
      <li #dropdown1="bs-dropdown" *ngIf="hasResidenzProduct()" [hidden]="false" class="nav-item dropdown" dropdown>
        <a (click)="onDropdownClicked($event)"
           class="nav-link dropdown-toggle waves-light pl-3 pr-3"
           data-cy="communicationsMenu"
           dropdownToggle
           mdbRippleRadius
           type="button">
          <span><img src="assets/images/navbar/communications.svg"/>{{ Localization.Communications | translate }}<span
            class="caret"></span></span>
        </a>
        <div (click)="onEvent($event)" class="dropdown-menu dropdown-menu-right" id="message-center">
          <a *ngIf="isResidenzMessagesListEmpty()"
             class="dropdown-item disabled">{{ Localization.YouHaveNoNewInformation | translate }}</a>
          <ng-container *ngFor="let message of residenzMessages; last as isLast">
            <div (click)="goToMessageRedirectUrl(message.getRedirectUrl())"
                 class="clickable p-1 text-left dropdown-item">
              <img class="messagecenter-icon" src="assets/images/navbar/residenz_message.svg" width="16">
              <span class="ml-2">{{ message.getMessage() }}</span>
            </div>
            <div [hidden]="isLast" class="divider dropdown-divider"></div>
          </ng-container>
          <div class="divider dropdown-divider"></div>
          <a (click)="addNewResidentNotification()"
             class="dropdown-item p-1">
            <i class="fa fa-plus-square mr-2"></i> {{ Localization.NewResidentNotification | translate}}
          </a>
        </div>
      </li>
      <li *ngIf="!shouldShowOnlyAccountSection() && canUserViewContacts() | async"
          [ngClass]="{ 'active amber rounded': isContactsButtonActive }"
          class="nav-item">
        <a class="nav-link waves-light pl-3 pr-3" mdbRippleRadius routerLink="/contacts" routerLinkActive="active">
          <span> <img src="assets/images/navbar/contacts.svg"/> {{ Localization.Contacts | translate }}</span>
        </a>
      </li>
      <li *ngIf="(canUserViewPayment() | async) || forceDisplayPaymentWizardInMenu()" class="nav-item">
        <a class="rounded nav-link waves-light pl-3 pr-3" mdbRippleRadius routerLink="/payment"
           routerLinkActive="active amber rounded">
          <span> <img src="assets/images/navbar/credit-card.svg"/> {{ Localization.Subscription | translate }}</span>
        </a>
      </li>

      <li #dropdown1="bs-dropdown" [hidden]="shouldShowOnlyAccountSection()"
          [ngClass]="{ 'active amber rounded': areSettingsActive }" class="nav-item dropdown"
          dropdown>
        <a (click)="dropdown2.hide()" class="nav-link dropdown-toggle waves-light pl-3 pr-3" dropdownToggle
           mdbRippleRadius
           mdbRippleRadius type="button">
          <i class="fa fa-cog mr-1"></i>
          <span class="d-xl-none">{{ Localization.Settings | translate }}</span>
          <span class="caret"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <a (click)="dropdown1.hide()" *ngIf="canUserViewRoles() | async" [class.active]="areRolesActive"
             class="dropdown-item waves-light" mdbRippleRadius routerLink="/roles">
            <i class="fa fa-masks-theater mr-1"></i>
            <span>{{ Localization.Roles | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="canUserViewAccounts() | async" [class.active]="areAccountsActive"
             class="dropdown-item waves-light" mdbRippleRadius routerLink="/accounts">
            <i class="fa fa-address-book mr-1"></i>
            <span>{{ Localization.Logins | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()"
             *ngIf="hasMaintenanceProduct"
             class="dropdown-item waves-light"
             routerLink="/maintenance/intervention-teams/teams">
            <i class="fa fa-users mr-1"></i>
            <span>{{ Localization.InterventionTeams | translate }}</span>
          </a>
          <a *featureFlag="'ManagerBuildingExecutorsView'"
             class="dropdown-item waves-light"
             mdbRippleRadius
             routerLink="/executors"
             routerLinkActive="active">
            <i class="fa fa-user-friends mr-1"></i>
            <span>{{ Localization.Executors | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="permissionsService.doesUserHavePermissionToViewDevices() | async"
             [class.active]="areDevicesActive" class="dropdown-item waves-light" mdbRippleRadius
             routerLink="/devices">
            <i class="fa fa-desktop mr-1"></i>
            <span>{{ Localization.Devices | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="permissionsService.doesUserHavePermissionToViewPartners() | async"
             [class.active]="arePartnersActive" class="dropdown-item waves-light" mdbRippleRadius
             routerLink="/partners">
            <i class="fas fa-handshake mr-1"></i>
            <span>{{ Localization.PartnersSettings | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="canUserViewReportSettings() | async"
             [class.active]="areReportSettingsActive"
             class="dropdown-item waves-light" mdbRippleRadius routerLink="/report-settings">
            <i class="fa fa-bar-chart mr-1"></i>
            <span>{{ Localization.ReportSettings | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="permissionsService.doesUserHavePermissionToViewContacts() | async"
             [class.active]="isExportActive" class="dropdown-item waves-light" mdbRippleRadius
             routerLink="/export">
            <i class="fa fa-download mr-1"></i>
            <span>{{ Localization.Export | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" *ngIf="permissionsService.doesUserHavePermissionToEditContacts() | async"
             [class.active]="isImportActive" class="dropdown-item waves-light" mdbRippleRadius
             routerLink="/import/contacts">
            <i class="fa fa-upload mr-1"></i>
            <span>{{ Localization.Import | translate }}</span>
          </a>
          <a (click)="dropdown1.hide()" [class.active]="isFeedbackActive" class="dropdown-item waves-light"
             mdbRippleRadius
             routerLink="/feedback">
            <i class="fa fa-commenting mr-1"></i>
            <span>{{ Localization.Feedback | translate }}</span>
          </a>
        </div>
      </li>
      <li #dropdown2="bs-dropdown" [ngClass]="{ 'active amber rounded': isAccountGroupActive }"
          class="nav-item dropdown"
          dropdown>
        <a (click)="dropdown1.hide()" class="nav-link dropdown-toggle waves-light pl-3 pr-3" dropdownToggle
           mdbRippleRadius
           mdbRippleRadius type="button">
          <i class="fa fa-user-circle mr-1"></i>
          <span class="d-xl-none">{{ Localization.Account | translate }}</span>
          <span class="caret"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <h6 class="dropdown-header">
            <div class="mb-2">
              <strong>{{ getUsername() }}</strong>
            </div>
            <div>
              <a (click)="navigateToProfile()" class="pl-0">{{
                getUserEmail()
                }}</a>
            </div>
          </h6>
          <div class="divider dropdown-divider"></div>
          <a (click)="dropdown2.hide()" [class.active]="isBusinessActive" class="dropdown-item waves-light"
             mdbRippleRadius
             routerLink="/business">
            <i class="fa fa-institution mr-1"></i>
            <span>{{ Localization.BusinessInfo | translate }}</span>
          </a>
          <a (click)="dropdown2.hide()" [class.active]="isLicenseActive" class="dropdown-item waves-light"
             mdbRippleRadius
             routerLink="/license">
            <i class="fa fa-legal mr-1"></i>
            <span>{{ Localization.LicenseAgreement | translate }}</span>
          </a>
          <a (click)="dropdown2.hide()" *ngIf="canUserViewPayment() | async"
             class="dropdown-item waves-light" mdbRippleRadius routerLink="/subscription"
             routerLinkActive="active">
            <i class="fa fa-credit-card mr-1"></i>
            <span>{{ Localization.TransactionHistory | translate }}</span>
          </a>
          <div class="divider dropdown-divider"></div>
          <a (click)="logout()" class="dropdown-item waves-light" mdbRippleRadius>
            <i class="fa fa-sign-out mr-1"></i>
            <span>{{ Localization.Logout | translate }}</span>
          </a>
        </div>
      </li>
    </ul>
  </links>
</mdb-navbar>
